(() => {
	angular.module('main').directive('addPromoCodeModal', addPromoCodeModal);

	addPromoCodeModal.$inject = [];

	function addPromoCodeModal() {
		return {
			restrict: 'E',
			scope: {
				campaign: '<',
				submitPromoCode: '&',
				btnDisable: '<'
			},
			template: `
                    <div id="addPromoCode" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog" style="max-width: 620px">
                                <div class="modal-content">
                                    <form class="form-horizontal" ng-submit="submitPromoCode({campaign:campaign})">
                                        <div class="modal-header">
                                           <btn-close></btn-close>
                                            <h3 class="modal-title">{{campaign.id ? 'Extend promo code' : 'Add new promo code'}}</h3>
                                        </div>
                                        <div class="modal-body">
                                                <div class="row form-group">
                                                    <label class="col-sm-3 control-label text-left">Campaign name</label>
                                                    <div class="col-sm-9">
                                                        <input type="text" class="form-control" ng-model="campaign.name" required>
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col-sm-3 control-label text-left">Promo code</label>
                                                    <div class="col-sm-9">
                                                        <input type="text" class="form-control" ng-model="campaign.code" ng-disabled="campaign.id" required>
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col-sm-3 control-label text-left">Discount (Year 1)</label>
                                                    <div class="col-sm-9">
                                                        <input type="number" class="form-control transition-0" 
                                                                ng-model="campaign.discount" ng-disabled="campaign.id"
                                                                min="0"
                                                                max="100"
                                                                maxlength="3"
                                                                placeholder="discount"
                                                                step="1"
                                                                data-number-to-fixed="0"
                                                                data-number-stepfactor="1" required>
                                                    </div>
                                                </div>
                                                <div class="row form-group">
                                                        <div>
                                                            <label class="col-sm-3 control-label text-left">Duration</label>
                                                        </div>
                                                        <div class="col-sm-9 job-date">
                                                             <div class="flex-row flex-wrap-xs">
                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0">
                                                                    <input ng-model="campaign.startDate" class="form-control"
                                                                           ng-disabled="campaign.id"
                                                                           type="date" name="input" data-placeholder="dd/mm/yyyy"
                                                                           min="2001-12-31"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                                <div class="flex-basis-xs ms-15">to</div>
                                                                <div class="flex-grow-1 box-no-transition datepicker-static bottom-0 left-n-136">
                                                                    <input ng-model="campaign.endDate" class="form-control"
                                                                          type="date" name="input" data-placeholder="dd/mm/yyyy"
                                                                           min="{{( campaign.startDate ) ? ( campaign.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                      
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button type="submit"
                                                    class="btn btn-success btn-lg"
                                                    ng-disabled="btnDisable"
                                                    spinning-wheel is-spinning-wheel-active="btnDisable"
                                            >Save promo code
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.campaign = {};

				scope.$watch('campaign.startDate', checkCodeDate);

				function checkCodeDate(startDate) {
					if (
						scope.campaign &&
						(!scope.campaign.endDate || startDate > scope.campaign.endDate)
					) {
						scope.campaign.endDate = startDate;
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/admin/addPromoCodeModal.js